import React from 'react';
import { BorrowerNameChecker } from './pages/BorrowerNameChecker';
export function App() {
  return <BorrowerNameChecker data-id="element-0" />;
}